import { createFileRoute } from '@tanstack/react-router';

import DoubleInputSearchPage from '../../components/DoubleInputSearchPage/DoubleInputSearchPage';

export const Route = createFileRoute('/_auth/part/')({
  component: DoubleInputSearchPage,
});
